import { Controller } from "@hotwired/stimulus"

// Reveals/hides the guardian picker on the admin member form based on the
// "dependent" switch. Also handles the inline "create new responsible adult"
// disclosure inside the picker.
export default class extends Controller {
  static targets = ["dependentToggle", "guardianBlock", "inlineCreateLink", "inlineCreateBlock"]
  static values = { dependent: Boolean }

  connect() {
    this.applyVisibility()
  }

  toggle() {
    this.applyVisibility()
  }

  applyVisibility() {
    const isDependent = this.hasDependentToggleTarget && this.dependentToggleTarget.checked
    if (this.hasGuardianBlockTarget) {
      this.guardianBlockTarget.classList.toggle("hidden", !isDependent)
    }
  }

  revealInlineCreate(event) {
    event.preventDefault()
    if (this.hasInlineCreateBlockTarget) {
      this.inlineCreateBlockTarget.classList.remove("hidden")
    }
    if (this.hasInlineCreateLinkTarget) {
      this.inlineCreateLinkTarget.classList.add("hidden")
    }
  }
}
